import { setTranslations } from './core'

const INIT_CACHE: Record<string, Promise<unknown>> = {}

export async function memoizedInitializeLocalization(
  locale: string,
  localeFileUrl: string | Promise<string>,
): Promise<void> {
  if (!(locale in INIT_CACHE)) {
    INIT_CACHE[locale] = fetchLocale(await localeFileUrl)
  }

  try {
    const translations = await INIT_CACHE[locale]
    if (translations !== undefined) {
      setTranslations(translations)
    } else {
      // TODO: Sentry
      console.error(`Locale ${locale} cannot be loaded`)
      setTranslations({})
    }
  } catch (e) {
    setTranslations({})
  }
}

async function fetchLocale(localeFileUrl: string): Promise<unknown> {
  const response = await fetch(localeFileUrl)

  if (response.ok) {
    const translations = await response.json()
    return translations
  }
}

export async function initializeLocalization(locale: string, localeFileUrl: string | Promise<string>): Promise<void> {
  try {
    const response = await fetch(await localeFileUrl)

    if (response.ok) {
      const translations = await response.json()
      console.info(`Locale ${locale} has been correctly loaded`)
      setTranslations(translations)
    } else {
      // TODO: Sentry
      console.error(`Locale ${locale} cannot be loaded (error: ${response.statusText})`)
      setTranslations({})
    }
  } catch (e) {
    setTranslations({})
  }
}

export * from './core'
export * from './stubs'
